// extracted by mini-css-extract-plugin
export default {"section":"FlexTemplate-module__section--y0EMG"};